import React from 'react';
import { ReactComponent as BeTheHostIcon } from '../../assets/questBadges/create_event.svg';
import { ReactComponent as CloakIcon } from '../../assets/questBadges/use_invisible_keys.svg';
import { ReactComponent as CuriousLearnerIcon } from '../../assets/questBadges/attend_education_events.svg';
import { ReactComponent as FriendsOverGoldIcon } from '../../assets/questBadges/invite_friends.svg';
import { ReactComponent as LockpicksIcon } from '../../assets/questBadges/use_lockpick.svg';
import { ReactComponent as NetworkBuilderIcon } from '../../assets/questBadges/map_connections.svg';
import { ReactComponent as CuriousEyesIcon } from '../../assets/questBadges/get_opened_by_other.svg';
import { ReactComponent as PartyConnectorIcon } from '../../assets/questBadges/attend_party_events.svg';
import { ReactComponent as RecreationExplorerIcon } from '../../assets/questBadges/attend_recreation_events.svg';
import { ReactComponent as SocialAthleteIcon } from '../../assets/questBadges/attend_sport_events.svg';
import { ReactComponent as LookingForYouIcon } from '../../assets/questBadges/get_found_by_search.svg';
import { ReactComponent as TravelCompanionIcon } from '../../assets/questBadges/attend_traveling_events.svg';
import { ReactComponent as TreasureSeekerIcon } from '../../assets/questBadges/open_vaults.svg';
import { ReactComponent as WithoutKnockingIcon } from '../../assets/questBadges/use_level4key_on_level1vault.svg';
import './QuestBadge.css';

// User-selected artwork, matching the fourteen badge rows in the supplied screenshot.
// One SVG per quest; the tier changes only its finish, never its silhouette.
const CUSTOM_ICONS = {
  create_event: BeTheHostIcon,
  use_invisible_keys: CloakIcon,
  attend_education_events: CuriousLearnerIcon,
  invite_friends: FriendsOverGoldIcon,
  use_lockpick: LockpicksIcon,
  map_connections: NetworkBuilderIcon,
  get_opened_by_other: CuriousEyesIcon,
  attend_party_events: PartyConnectorIcon,
  attend_recreation_events: RecreationExplorerIcon,
  attend_sport_events: SocialAthleteIcon,
  get_found_by_search: LookingForYouIcon,
  attend_traveling_events: TravelCompanionIcon,
  open_vaults: TreasureSeekerIcon,
  use_level4key_on_level1vault: WithoutKnockingIcon,
};

// Existing fallback drawings for tasks outside the current badge catalogue.
const QUEST_ICONS = {
  change_key_lock: <><rect x="5" y="10" width="14" height="11" rx="2" /><path d="M8 10V7a4 4 0 0 1 8 0v3m-4 4v3" /></>,
  change_castle_skin: <><path d="M3 21V9h4V5h4v4h2V5h4v4h4v12H3Zm6 0v-5a3 3 0 0 1 6 0v5" /></>,
  change_lock_skin: <><rect x="5" y="10" width="14" height="11" rx="2" /><path d="M8 10V7a4 4 0 0 1 8 0v3m-4 5 2-2m-2 2-2-2" /></>,
  upgrade_first_time: <><path d="M12 21V4m-5 5 5-5 5 5M4 17v4h16v-4" /></>,
  first_claim: <><path d="M12 2 5 5v6c0 5 3 8 7 11 4-3 7-6 7-11V5l-7-3Zm-3 10 2 2 4-4" /></>,
  add_to_favorites: <path d="M20.5 8.5c0 4.4-8.5 10.5-8.5 10.5S3.5 12.9 3.5 8.5a4.6 4.6 0 0 1 8.5-2.4 4.6 4.6 0 0 1 8.5 2.4Z" />,
  create_subscription: <><path d="M5 18h14l-2-3V9a5 5 0 0 0-10 0v6l-2 3Zm5 3h4" /></>,
  add_about_info: <><circle cx="12" cy="12" r="9" /><path d="M12 11v6m0-10h.01" /></>,
  add_social_contact: <><circle cx="9" cy="8" r="3" /><path d="M3 20v-2a6 6 0 0 1 12 0v2m2-12h5m-2.5-2.5v5" /></>,
  add_events_to_vault: <><rect x="3" y="4" width="18" height="17" rx="2" /><path d="M7 2v4m10-4v4M3 9h18m-12 4 3 3 4-4" /></>,
  join_events: <><circle cx="8" cy="8" r="3" /><path d="M2 20v-2a6 6 0 0 1 12 0v2m3-11v8m-4-4h8" /></>,
};

export default function QuestBadge({ slug, level = 1, size = 48, muted = false, className = '' }) {
  const tier = Math.max(1, Math.min(5, Number(level) || 1));
  const CustomIcon = CUSTOM_ICONS[slug];
  return (
    <span
      className={`vg-quest-badge vg-quest-badge--tier-${tier}${muted ? ' vg-quest-badge--muted' : ''} ${className}`}
      style={{ '--vg-badge-size': `${size}px` }}
      aria-hidden="true"
    >
      {CustomIcon ? <CustomIcon /> : <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.65" strokeLinecap="round" strokeLinejoin="round">
        {QUEST_ICONS[slug] || <><path d="m12 3 2.6 6.4L21 12l-6.4 2.6L12 21l-2.6-6.4L3 12l6.4-2.6L12 3Z" /></>}
      </svg>}
    </span>
  );
}
